import DataService from "@shared/services/DataService";
import { generateFeedbackToken, RENDER_CHECK_TYPES } from "../hooks/generateToken";
import DataStore from "@shared/services/DataStore";

class FeedbackFormService {
    /**
     * Step 1: get v2 token (customerId, accessToken, redirectAccessToken)
     * Step 2: call render-check with { type, ...payload }
     * Step 3: if render === true, build the form-render URL using formName
     *
     * @param {Object} params
     * @param {"ADD_BENEFICIARY"|"POST_TRANSACTION"} params.type
     * @param {Object} [params.payload={}]
     * @param {string} [params.lang="en"]
     * @returns { shouldRender: boolean, webViewUrl?: string, formName?: string, reason?: string } //returns a promise
     */
    async resolveFeedbackForm({ type, payload = {}, lang = "en" }) {
        if (!Object.values(RENDER_CHECK_TYPES).includes(type)) {
            return { shouldRender: false, reason: `Unsupported render-check type: ${type}` };
        }

        // 1. Get v2 token
        const tokenData = await generateFeedbackToken();
        if (!tokenData?.accessToken) {
            return { shouldRender: false, reason: "Failed to generate feedback token" };
        }

        const { accessToken, redirectAccessToken } = tokenData;

        const NODE_FOLIO_BASE_URL = `${DataStore.getNodeFolioServiceBaseUrl()}/folio`;
        const RENDER_CHECK_ENDPOINT = `${NODE_FOLIO_BASE_URL}/api/v1/form/render-check`;
        const FORM_RENDER_BASE = `${NODE_FOLIO_BASE_URL}/api/v1/redirect/form`;

        // 2. Render check — body is { type, ...whatever the caller passed in payload }
        let renderCheckRes;
        try {
            renderCheckRes = await DataService.post(
                RENDER_CHECK_ENDPOINT,
                { type, ...payload },
                { headers: { Authorization: `Bearer ${accessToken}` }, ignorePrefix: true }
            );
        } catch (err) {
            console.error("Render-check API failed", err);
            return { shouldRender: false, reason: "Render-check request failed" };
        }

        const { render, formName, context, message = "No message from render check api" } = renderCheckRes || {};

        // 3. If render is false, stop here — do NOT call API 2
        if (!render) {
            console.error("Server Response: ", message);
            return { shouldRender: false, reason: "Server indicated form should not render" };
        }

        if (!formName) {
            console.error("Server Response: ", message);
            return { shouldRender: false, reason: "render=true but formName missing" };
        }

        // 4. Build form-render URL (API 2 is a GET the iframe itself will hit)
        const dataParam = encodeURIComponent(
            JSON.stringify({ formName, platform: "KIOSK", lang, flutter: false, context })
        );
        const webViewUrl = `${FORM_RENDER_BASE}?redirectAccessToken=${encodeURIComponent(
            redirectAccessToken
        )}&data=${dataParam}`;

        return { shouldRender: true, webViewUrl, formName };
    }
}

export default new FeedbackFormService();
